import { Button, Switch, TextButton } from '~components/web-components'
import { Box, Divider, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Cookie } from '../cookie-banner'
import { getStoredCookies } from '../utils/get-stored-cookies'
import { saveCookieSettings } from '../utils/save-cookie-settings'
import { AcceptAllButton } from './accept-all-button'
import { CookieDetails } from './cookie-details'

export const StyledSecondaryButton = styled(Button)`
  max-width: 255px;
`

export function CookieSettings({
  onClickHandler,
  closeModal,
}: {
  onClickHandler: () => void
  closeModal: () => void
}) {
  const [allowedCookies, setAllowedCookies] = useState<Set<Cookie>>(new Set())

  useEffect(() => {
    const storedCookies = getStoredCookies()
    if (storedCookies.includes(Cookie.statistical)) {
      setAllowedCookies(new Set([Cookie.statistical]))
    }
  }, [])

  function toggleCookie(cookie: Cookie) {
    allowedCookies.has(cookie)
      ? allowedCookies.delete(cookie)
      : allowedCookies.add(cookie)

    setAllowedCookies(new Set(allowedCookies))
  }

  return (
    <>
      <Typography>
        Some are used for statistical purposes and others are set up by third
        party services. By clicking ‘Accept all’, you accept the use of cookies.
      </Typography>
      <TextButton onClick={onClickHandler}>About cookies</TextButton>

      <Box sx={{ display: 'flex', gap: 4, my: 3 }}>
        <StyledSecondaryButton
          variant="outlined"
          onClick={() => {
            saveCookieSettings(allowedCookies)
            closeModal()
          }}
        >
          {allowedCookies.has(Cookie['statistical'])
            ? 'Update consent'
            : 'Use necessary cookies only'}
        </StyledSecondaryButton>
        <AcceptAllButton closeModal={closeModal} />
      </Box>

      <CookieDetails />

      <Divider sx={{ my: 4 }} />
      <Box sx={{ display: 'flex', gap: 4 }}>
        <Switch
          name="Strictly necessary"
          label="Strictly necessary"
          checked
          disabled
        />
        <Switch
          name="Statistical"
          label="Statistical"
          onChange={() => toggleCookie(Cookie.statistical)}
          checked={allowedCookies.has(Cookie.statistical)}
        />
      </Box>
    </>
  )
}
